import { env } from "@/env.mjs";

export const rootURL = new URL(env.NEXT_PUBLIC_ROOT_URL);
export const rootDomain = rootURL.host;

export const getStoreBaseUrl = (store: { domain?: string | undefined | null; subdomain: string }) => {
	const baseUrl = `${rootURL.protocol}//${store.domain ? store.domain : `${store.subdomain}.${rootDomain}`}`;
	return baseUrl;
};

export const getStoreSubdomainUrl = (store: { subdomain: string }) => {
	const baseUrl = `${rootURL.protocol}//${store.subdomain}.${rootDomain}`;
	return baseUrl;
};

export const MAX_STORES = 2;
export const AdminList = [
	// staging
	"user_2l3Fy2fypVQtHF5I33na9mM50Ds",
	"user_2jbyNlxAT14cfvEo8xrYC6j5fN6",
	"user_2r4SEoUKt1XRvhA9qHW2pDJxiic", // bartosz guzdziol
	"6606Sel7bJFTSWC4NjzFEyJubVjvkrEd", // Szymon

	// production
	"user_2rcnaEHqsE29538k9MbDQa5vWAi",
	"05mgY1e8nggbreeUAHlYMgNifaLzYweh", // Szymon gmail
	"GzPlLNXWqRsBwJXwchvOXYdeGg20yaIV", // Szymon yournextstore
];

export const getStripeProductId = () =>
	env.VERCEL_ENV === "production" ? "prod_RFkukB04BRtWda" : "prod_RDbS14WbriBIVN";

export const getStripeSecretKey = () => {
	// on production, we always use production key for payments – even if customer is in test mode
	return env.VERCEL_ENV === "production"
		? env.ROOT_STRIPE_SECRET_KEY_PRODUCTION
		: env.ROOT_STRIPE_SECRET_KEY_TEST;
};

export const NULL_STR = "__NULL__";
